import React from 'react';
import round from 'lodash/round';

import { useTranslation } from '@lyearn/i18n';
import {
  CheckMarkFillLegacy,
  Mastery1Outline,
  Mastery2Outline,
  Mastery3Outline,
  Mastery4Outline,
} from '@lyearn/icons';
import { Box, Stack, StatusPill, Typography } from '@lyearn/ui';

const getProgressPillIcon = (progress: number) => {
  if (progress === 100) {
    return CheckMarkFillLegacy;
  } else if (progress >= 40 && progress < 60) {
    return Mastery2Outline;
  } else if (progress >= 60 && progress < 80) {
    return Mastery3Outline;
  } else if (progress >= 80 && progress < 100) {
    return Mastery4Outline;
  }
  return Mastery1Outline;
};

interface ProgressProps {
  progress: number;
}

const Progress = ({ progress }: ProgressProps) => {
  const { t } = useTranslation();
  const isCompleted = progress === 100;
  const appearance = isCompleted ? 'success' : 'warning';
  const textColor = isCompleted ? 'text-text-success' : 'text-text-warning';
  const iconColor = isCompleted ? 'icon-success' : 'icon-warning';
  const Icon = getProgressPillIcon(progress);

  return (
    <Box className="mt-auto">
      <StatusPill
        appearance={appearance}
        label={
          <Stack alignItems="center" gapX={6}>
            {Icon && <Icon className="h-16 w-16 self-center" fillColorToken={iconColor} />}
            <Typography color={textColor} variant="label-02">
              {`${round(progress, 0)}%`}
            </Typography>
          </Stack>
        }
        variant="light"
      />
    </Box>
  );
};

export default React.memo(Progress);
